import {Alert, Stack} from '@mui/material';
import {FormProvider, SubmitHandler} from 'react-hook-form';
import {useLocation, useNavigate} from 'react-router';
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {LoginRequest, useLoginForm} from '@services/Schemas/LoginSchema';
import {useLoginMutation} from '@services/securityApi';
import SubmitButton from '@atoms/Buttons/SubmitButton';
import ApiError from '@molecules/Errors/ApiError';
import FormTextInput from '@molecules/Inputs/FormTextInput';
import Form from '@organisms/Forms/Form';
import useT from '@hooks/useT';

interface LocationState {
    from?: {
        pathname: string;
    };
    message?: string;

}

function LoginForm() {
    const { t } = useT();
    const [triggerLogin, {error}] = useLoginMutation();
    const navigate = useNavigate();
    const location = useLocation();

    const {executeRecaptcha} = useGoogleReCaptcha();

    const {from, message} = (location.state as LocationState | null) ?? {};

    const redirectTo = from?.pathname ?? '/';

    const loginSubmit: SubmitHandler<LoginRequest> = async (data) => {
        if (!executeRecaptcha) return;
        const recaptchaToken = await executeRecaptcha('login');
        await triggerLogin({...data, recaptchaToken})
            .unwrap()
            .then((response) => {
                if (response.idClient === -1)

                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    navigate('/sysadmin');
                else {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    navigate(redirectTo, {replace: true});
                }

            });
    };

    const methods = useLoginForm();

    return (
        <FormProvider {...methods}>
            <Form onSubmit={loginSubmit} data-testid="login-form">
                <Stack spacing={2}>
                    {message && <Alert severity="warning" data-testid="login-warning-message">{message}</Alert>}
                    <ApiError error={error} data-testid="login-error-message"/>
                    <FormTextInput
                        name="courriel"
                        label={t('fields.email')}
                        required
                        slotProps={{htmlInput: {'data-testid': 'login-email-input'}}}
                    />
                    <FormTextInput
                        name="password"
                        label={t('utilisateur.passwordLabel')}
                        type="password"
                        required
                        slotProps={{htmlInput: {'data-testid': 'login-password-input'}}}
                    />
                    <SubmitButton data-testid="login-submit-button">{t('actions.continue')}</SubmitButton>
                </Stack>
            </Form>
        </FormProvider>
    );
}

export default LoginForm;
